export default __webpack_public_path__ + "assets/images/Delete-678d67714cd2c17b20cddf9ccc0f9fa3.svg";